import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

/**
 * Language toggle button — cycles between supported languages (en ↔ es).
 *
 * Extracted from AuthLayout and DashboardShell to avoid duplication.
 */
export function LanguageToggle() {
  const { i18n, t } = useTranslation();

  const toggleLanguage = () => {
    const next = i18n.language === "es" ? "en" : "es";
    i18n.changeLanguage(next);
  };

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      className="flex h-9 items-center gap-1.5 rounded-lg px-2.5 text-xs font-medium text-muted transition-colors hover:bg-elevated hover:text-heading"
      aria-label={t("common.switchLanguage")}
    >
      <Globe size={14} />
      <span className="uppercase">{i18n.language}</span>
    </button>
  );
}
